export type UnreadMessageRow = {
  authorId: string;
  createdAt: string;
  deletedAt?: string | null;
};

const EPOCH = new Date(0).toISOString();

export function countUnreadMessages(
  messages: UnreadMessageRow[],
  opts: { lastReadAt: string | null; currentUserId: string },
): number {
  const lastRead = opts.lastReadAt ?? EPOCH;
  return messages.filter((m) => {
    if (m.deletedAt) return false;
    if (m.authorId === opts.currentUserId) return false;
    return m.createdAt > lastRead;
  }).length;
}

export function formatUnreadBadge(count: number): string | null {
  if (count <= 0) return null;
  return count > 99 ? '99+' : String(count);
}
